import axios from "./axiosConfig";
import i18n from '../i18n';

const addLang = (url) => {
  const lang = i18n.language || 'en';
  const separator = url.includes('?') ? '&' : '?';
  return `${url}${separator}lang=${lang}`;
};

export function getRequest(URL, headers = null) {
  const urlWithLang = addLang(URL);
  return axios.get(urlWithLang, headers).then(response => response);
}

export function postRequest(URL, payload, headers = null) {
  return axios.post(addLang(URL), payload, headers)
    .then(response => response)
    .catch(error => {
      if (error.response && error.response.status === 400) {
        return Promise.reject( error.response.data)
      } else {
        return error.response;
      }
    });
}

export function patchRequest(URL, payload, headers = null) {
  return axios.patch(addLang(URL), payload, headers).then(response => response)
  .catch((error)=> console.log(error));
}

export function deleteRequest(URL, headers = null) {
  return axios.delete(addLang(URL), headers).then(response => response);
}
